import { isProduction } from 'lib/utility/ApplicationConfig'

const protocol = process.env.REACT_APP_TA_PROTOCOL
const subDomain = process.env.REACT_APP_TA_SUB_DOMAIN
const domainName = process.env.REACT_APP_TA_DOMAIN_NAME
const topLevelDomain = process.env.REACT_APP_TA_TOP_LEVEL_DOMAIN

const textAnalysisURL = `${protocol}${subDomain}.${domainName}.${topLevelDomain}`

export const getBaseURL = () => {
  const url = isProduction()
    ? window.location.origin
    : (process.env.REACT_APP_BASE_URL as string)

  return url
}

export const getBaseURLTextAnalysis = () => {
  return textAnalysisURL
}

// To understand more please look into itsfadnis/jsonapi-client module
// here: (https://github.com/itsfadnis/jsonapi-client/blob/master/src/model.ts#L141)

export const createQueryString = (params: any = {}, prefix = ''): string => {
  const query = Object.keys(params).map((k) => {
    let key: string = k
    const value = params[key]
    if (params.constructor === Array) {
      key = encodeURIComponent(`${prefix}[]`)
    } else if (params.constructor === Object) {
      key = prefix ? `${prefix}[${key}]` : key
    }
    if (typeof value === 'object') {
      return createQueryString(value, key)
    }
    return `${key}=${encodeURIComponent(value)}`
  })
  return [...query].join('&')
}
